import { API_CENTRE } from "./config";
import _o2sService from "./_o2sServices";
import { IFilter } from "../models/filters/filter";
import { IStockUnityFilter } from "../models/filters/stockUnityFilter";
import { IStockUnityForm } from "../models/forms/stockUnityForm";
import { IStockUnityPDTO } from "../models/dtos/stockUnityPDTO";

export default class StockUnityService extends _o2sService {

    protected static override mainUrl:string = API_CENTRE + "/api/v1/StockUnity";

    protected static override  getUrlFilter<F extends IStockUnityFilter>(filter?: F):string {
        let url = super.getUrlFilter(filter as IFilter);
        if ( filter != null)
        {
            if(filter.CTime != undefined)
                url += `&CTime=${filter.CTime}`;
            if(filter.articleId != undefined)
                url += `&ArticleId=${filter.articleId}`;
        }
        
        return url;
    }

    public static override toDTO(obj:IStockUnityForm):IStockUnityPDTO {
        const dto = super.toDTO(obj) as IStockUnityPDTO;
        return dto;
    }
}